// extracted by mini-css-extract-plugin
export default {"commentContainer":"CommentCard_commentContainer__4agJt","commentName":"CommentCard_commentName__w1os7","commentEmail":"CommentCard_commentEmail__a8+ov"};